export const state = {
  account: null,
  transactions: [],
  pagination: { page: 1, limit: 20, total: 0 },
  loading: false,
  error: null
};
